/**
 * @vuelto-surface
 * mobile: ok
 * desktop: ok
 * strategy: inherit
 *
 * Barra superior del hub dueño (proto: `.shell` + org pill + salida a cuenta).
 */
import React, { useCallback } from 'react';
import { StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import type { NavigationProp, ParamListBase } from '@react-navigation/native';
import { spacing } from '../../shared/theme/spacing'
import { typography } from '../../shared/theme/typography'
import { colors } from '../../shared/theme/colors';
import { ticketColors } from '../../shared/theme/ticketColors';
import { OrganizationHubPill } from '../../shell/session/components/OrganizationHubPill';
import { navigateRoot } from '../../shell/navigation/rootNavigation';

type Props = {
  navigation: NavigationProp<ParamListBase>;
  branchCount: number;
};

export function PostLoginHubOwnerChrome({ navigation, branchCount }: Props) {
  const openAccount = useCallback(() => {
    navigateRoot(navigation, 'HubAccount');
  }, [navigation]);

  return (
    <View style={styles.wrap} testID="post-login-hub.owner-chrome">
      <View style={styles.pillSlot}>
        <OrganizationHubPill
          navigation={navigation}
          branchCount={branchCount}
          embedded
          identityNavigationContext="hub"
        />
      </View>
      <TouchableOpacity
        style={styles.accountBtn}
        onPress={() => void openAccount()}
        accessibilityRole="button"
        accessibilityLabel="Mi cuenta"
        testID="post-login-hub.account"
      >
        <Ionicons name="person-circle-outline" size={22} color={ticketColors.ink} />
        <Text style={styles.accountLabel}>Mi cuenta</Text>
      </TouchableOpacity>
    </View>
  );
}

const styles = StyleSheet.create({
  wrap: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: spacing.sm,
    paddingHorizontal: spacing.lg,
    paddingTop: spacing.md,
    paddingBottom: spacing.xs,
    backgroundColor: ticketColors.bg,
    borderBottomWidth: StyleSheet.hairlineWidth,
    borderBottomColor: ticketColors.rule,
  },
  pillSlot: {
    flex: 1,
    minWidth: 0,
  },
  accountBtn: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 4,
    paddingVertical: spacing.sm,
    paddingHorizontal: spacing.xs,
    flexShrink: 0,
  },
  accountLabel: {
    ...typography.caption,
    fontWeight: '700',
    color: colors.textSecondary,
  },
});
